import Vue from 'vue'
import Carbon from '@rhitics/core/libs/Carbon'

declare module 'vue/types/vue' {
  interface Vue {
    $carbon:  {
      now: (tz?: string) => Carbon,
      parse: (date: string | number | Date, tz?: string) => Carbon,
      today: (tz?: string) => Carbon,
      yesterday: (tz?: string) => Carbon,
      tomorrow: (tz?: string) => Carbon
    }
  }
}

export default function CarbonPlugin(V: typeof Vue) {
  V.prototype.$carbon = {
    now: (tz: string = 'UTC') => Carbon.now(tz),
    parse: (date: string | number | Date, tz: string = 'UTC') => Carbon.parse(date, tz),
    today: (tz: string = 'UTC') => Carbon.today(tz),
    yesterday: (tz: string = 'UTC') => Carbon.yesterday(tz),
    tomorrow: (tz: string = 'UTC') => Carbon.tomorrow(tz)
  }
}
